module.exports = __webpack_public_path__ + "img/symbol_3.b024bca3.png";